import customer from './customer'
import main from './main'
import searchCustomers from './searchCustomers'
import offerValidation from './offerValidation'
import removeInvalidOffer from './removeInvalidOffer'

export default {
  general: {
    appName: 'Thanx Loyalty',
    invalidBarcode: 'Code not valid',
    customerAlreadyAdded: 'There is already a customer added to this sale',
    pointsCurrencySingular: 'point',
    pointsCurrencyPlural: 'points',
  },
  main,
  searchCustomers,
  customer,
  offerValidation,
  removeInvalidOffer,
}
